module.exports = __webpack_public_path__ + "media/sounds/tap_02-1b717694f109c432dcb8eddb72edc62a.wav";